import api from './index';
//
let exports = {};

exports.getDeviceMaintPlanListForRent = function (data, callback) { // 获取租赁设备保养计划列表
    api.post('/shop/devc/maint/plan/list/get-forRent')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getDeviceMaintPlanList = function (data, callback) { // 获取设备保养计划列表
    api.post('/shop/device/maint/plan/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getDeviceMaintPlanDetail = function (params, callback) { // 获取设备保养计划列表
    api.get('/shop/device/maint/plan/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 设置设备保养计划预警小时数
exports.updateMaintPlanDeviceYqFinishAotHr = function (data, callback) { // 设置设备保养计划预警小时数
    api.post('/shop/device/maint/plan/device/yqFinishAotHr/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.deleteDeviceMaintPlan = function (params, callback) { // 删除设备保养计划
    api.post('/shop/device/maint/plan/delete/do')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doDeviceMaintPlanTermina = function (params, callback) { // 结束设备保养计划
    api.post('/shop/device/maint/plan/termina/do')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getLeasingDevcListByFilter = function (params, callback) { // 用于-出租设备列表
    api.post('/shop/devc/leasing/devc/list/get/by/filter')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getLeasingDevcList = function (data, callback) { // 出租设备列表
    api.post('/shop/devc/leasing/devc/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopDeviceSvcSubNoById = function (params, callback) { // 根据id获取设备信息
    api.get('/shop/devc/svc/sub/no/get/by/id')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateShopDeviceSvcSubNoStarted = function (data, callback) {
    api.post('/shop/devc/svcSubNo/useState/set/do')
    .data(data)
    .done(callback)
    .go();
};
// 设备操作记录
exports.getShopDeviceRecList = function (params, callback) {
    api.post('/shop/device/act/rec/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doLeasingDevcRent = function (params, callback) {
    api.post('/shop/devc/leasing/devc/rent')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doLeasingDevcRentBack = function (params, callback) {
    api.post('/shop/devc/leasing/devc/rent/back')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateLeasingDevcServicer = function (params, callback) {
    api.post('/shop/devc/leasing/devc/servicer/update')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 根据设备查找默认服务商信息
exports.getShopDeviceServicerBydeviceId = function (data, callback) {
    api.post('/shop/devc/defaulted/servicer/get/deviceId/and/servcType')
    .data(data)
    .done(callback)
    .go();
};

// ================= 巡检计划 ============================
// 巡检计划列表
exports.getDevcPatrolPlanList = function (data, callback) {
    api.post('/shop/device/patrol/plan/list')
    .data(data)
    .done(callback)
    .go();
};
// 巡检计划删除
exports.deleteDevcPatrolPlan = function (data, callback) {
    api.post('/shop/device/patrol/plan/delete')
    .data(data)
    .done(callback)
    .go();
};
// 巡检计划删除
exports.doDevcPatrolPlanTermina = function (data, callback) {
    api.post('/shop/device/patrol/plan/termina/do')
    .data(data)
    .done(callback)
    .go();
};
// 巡检计划查看
exports.getDevcPatrolPlanById = function (data, callback) {
    api.get('/shop/device/patrol/plan/get/by/id')
    .params(data)
    .done(callback)
    .go();
};

// 巡检计划查看
exports.getDevcPatrolPlanCheckCombCode = function (data, callback) {
    api.get('/shop/device/patrol/plan/checkCombCode/get')
    .params(data)
    .done(callback)
    .go();
};
// =============================
exports.getDevicePatrolPlanList = function (data, callback) {
    api.post('/shop/devc/patrol/plan/list')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 巡检计划新增
exports.saveDevcPatrolPlan = function (data, callback) {
    api.post('/shop/devc/patrol/plan/save')
        .data(data)
        .done(callback)
        .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/shopDevc.js
// module id = 38
// module chunks = 1